import {Action, di} from "@dp-instant/core";
import {TypesFlow} from "@dp-instant/interfaces";
import {parseLevelSVG} from "@game/coregame/helpers/parseLevelSVG";
import {LevelData} from "@game/coregame/interfaces/LevelData";
import {ContinentModel} from "@game/coregame/model/ContinentModel";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesGame} from "@game/TypesGame";
import {useCallback, useState} from "preact/hooks";
import {FileDropArea} from "./FileDropArea";

const parseLevelPromise = (file: File) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsText(file, "UTF-8");
        reader.onload = (e: ProgressEvent<FileReader>) => {
            try {
                const svgContent = e.target?.result as string;
                const svgDom = new window.DOMParser().parseFromString(svgContent, "text/xml");
                resolve(parseLevelSVG(svgDom));
            } catch (e) {
                reject(e);
            }
        };
    });
};
const clearCurrentField = () => {
    di.get<GameModel>(TypesGame.model).disposeCurrentLevel();
};
export const DebugLevelPicker = () => {
    const [, updateState] = useState({});
    const forceUpdate = useCallback(() => updateState({}), []);
    const model = di.get<GameModel>(TypesGame.model);
    return (
        <div>
            <select
                name="levels"
                id="levels-picker"
                onChange={a => {
                    const self = a.currentTarget as HTMLSelectElement;
                    const selected = self.item(self.selectedIndex) as HTMLOptionElement;
                    const selectedValue = selected?.value;
                    if (selectedValue) {
                        if (!selectedValue.startsWith(model.currentContinent.data.id)) {
                            clearCurrentField();
                            di.get<Action<string>>(TypesFlow.LevelStart).run(selectedValue);
                        }
                    }
                }}
            >
                {GameModel.LEVELS_PREDEFINED.concat(Object.keys(model.levels)).map(level => (
                    <option
                        value={level}
                        selected={level.startsWith(model.currentContinent.data.id!)}
                    >
                        {`${model.levels[level] ? "+" : ""}${level}`}
                    </option>
                ))}
            </select>
            <FileDropArea
                handleDrop={(files: FileList) => {
                    if (files && files.length > 0) {
                        const allPromises = [];
                        for (var i = 0; i < files.length; i++) {
                            const file = files[i];
                            if (file.name.endsWith(".svg")) {
                                allPromises.push(
                                    parseLevelPromise(file).then(data => {
                                        const model: GameModel = di.get(TypesGame.model);
                                        const continentModel = di
                                            .get<ContinentModel>(TypesGame.levelModel)
                                            .init(data as LevelData);
                                        model.levels[(data as LevelData).id] = continentModel;
                                        return Promise.resolve(continentModel);
                                    })
                                );
                            }
                            Promise.all(allPromises).then(results => {
                                if (results.length == 1) {
                                    const [firstLevel] = results;
                                    clearCurrentField();
                                    di.get<Action<string>>(TypesFlow.LevelStart).run(
                                        firstLevel.data.id
                                    );
                                }
                                forceUpdate();
                            });
                        }
                    }
                }}
            />
        </div>
    );
};
